import React, { useEffect } from 'react'
import { StepTitle } from '@components/layout/Form'
import PageContent from '@components/layout/PageContent'
import { useRouter } from 'next/router'

export default function SchedulerPage() {
  const router = useRouter()
  const { query } = router
  const { enrollmentId, territoryId } = query

  useEffect(() => {
    const inputVariables = [
      {
        name: 'enrollmentId',
        type: 'String',
        value: enrollmentId,
      },
      {
        name: 'territoryId',
        type: 'String',
        value: territoryId,
      },
    ]
    if (territoryId && enrollmentId) {
      const script = document.createElement('script')
      script.src = process.env.NEXT_PUBLIC_SF_LIGHTNING_URL
      script.async = true
      script.onload = () => {
        window.$Lightning.use(
          'runtime_appointmentbooking:lightningOutGuest',
          function () {
            window.$Lightning.createComponent(
              'lightning:flow',
              {},
              'flowContainer',
              function (component) {
                component.startFlow(
                  process.env.NEXT_PUBLIC_SF_FLOW_NAME,
                  inputVariables
                )
              }
            )
          },
          process.env.NEXT_PUBLIC_SF_ORG_BASE_URL
        )
      }
      const styleTag = document.createElement('style')
      styleTag.textContent = `.slds-visual-picker_vertical .slds-visual-picker__figure {
          height: inherit !important;}
          .runtime_appointmentbookingFlowLocation .slds-visual-picker_vertical {
          display: inline-flex !important;
          }`
      document.head.appendChild(styleTag)
      document.body.appendChild(script)
    }
  }, [enrollmentId, territoryId])

  return (
    <PageContent>
      <StepTitle>Book Your Appointment</StepTitle>
      <div id="flowContainer" />
    </PageContent>
  )
}
